import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  info: 'Your SIM Card is in the process of being cancelled and will continue working until the next recharge date ({rechargeDate}).',
  reactivateSim: 'Reactivate SIM',
})
